import Icon from "@ant-design/icons";
import type { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;
const ZipSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    viewBox="0 0 32 32"
  >
    <defs>
      <linearGradient
        id="SVGXr4mrHrF"
        x1={17.65}
        x2={21.099}
        y1={26.056}
        y2={26.056}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#4d4d4d"></stop>
        <stop offset={0.5} stopColor="#fff"></stop>
        <stop offset={1} stopColor="#4d4d4d"></stop>
      </linearGradient>
      <linearGradient
        id="SVG5oyStdai"
        x1={17.65}
        x2={21.099}
        y1={23.756}
        y2={23.756}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVG9QsNwcZU"
        x1={17.65}
        x2={21.099}
        y1={21.456}
        y2={21.456}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVG1kIgneZE"
        x1={17.65}
        x2={21.099}
        y1={19.156}
        y2={19.156}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGp2oQjdFa"
        x1={17.65}
        x2={21.099}
        y1={16.857}
        y2={16.857}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGAFV8AN5B"
        x1={17.65}
        x2={21.099}
        y1={14.557}
        y2={14.557}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGRkU6lbfc"
        x1={17.65}
        x2={21.099}
        y1={12.257}
        y2={12.257}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGWUBOGcFP"
        x1={17.65}
        x2={21.099}
        y1={9.957}
        y2={9.957}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGFcdVfdXh"
        x1={17.65}
        x2={21.099}
        y1={7.657}
        y2={7.657}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGLioYKc8j"
        x1={16.237}
        x2={19.686}
        y1={27.217}
        y2={27.217}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGIx7REdei"
        x1={16.237}
        x2={19.686}
        y1={24.918}
        y2={24.918}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGownHpeLf"
        x1={16.237}
        x2={19.686}
        y1={22.618}
        y2={22.618}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGZ4gzmcVN"
        x1={16.237}
        x2={19.686}
        y1={20.318}
        y2={20.318}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGhAblbd0u"
        x1={16.237}
        x2={19.686}
        y1={18.018}
        y2={18.018}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGBzD5PbgA"
        x1={17.65}
        x2={21.099}
        y1={28.356}
        y2={28.356}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGcXb6lbYS"
        x1={16.237}
        x2={19.686}
        y1={15.718}
        y2={15.718}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGKF6nobvx"
        x1={16.237}
        x2={19.686}
        y1={13.419}
        y2={13.419}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGrU8zSORM"
        x1={16.237}
        x2={19.686}
        y1={11.119}
        y2={11.119}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGuFw9gbIu"
        x1={16.237}
        x2={19.686}
        y1={8.819}
        y2={8.819}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGXh7zWblD"
        x1={16.237}
        x2={19.686}
        y1={29.514}
        y2={29.514}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGmzaoUw6y"
        x1={16.985}
        x2={20.446}
        y1={11.196}
        y2={11.196}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGkZYaOeHC"
        x1={18.096}
        x2={19.336}
        y1={5.329}
        y2={5.329}
        href="#SVGXr4mrHrF"
      ></linearGradient>
      <linearGradient
        id="SVGVKO9QdOI"
        x1={16.029}
        x2={21.403}
        y1={5.591}
        y2={5.591}
        href="#SVGXr4mrHrF"
      ></linearGradient>
    </defs>
    <path
      fill="#c09553"
      d="M27.667 27.667V17.333L23 15V2H4.333v28h23.334Zm-4.667 0v-9.111l2.333 1.222v7.889Z"
    ></path>
    <path fill="url(#SVGXr4mrHrF)" d="M17.65 25.559h3.45v.993h-3.45z"></path>
    <path fill="url(#SVG5oyStdai)" d="M17.65 23.26h3.45v.993h-3.45z"></path>
    <path fill="url(#SVG9QsNwcZU)" d="M17.65 20.96h3.45v.993h-3.45z"></path>
    <path fill="url(#SVG1kIgneZE)" d="M17.65 18.66h3.45v.993h-3.45z"></path>
    <path fill="url(#SVGp2oQjdFa)" d="M17.65 16.36h3.45v.993h-3.45z"></path>
    <path fill="url(#SVGAFV8AN5B)" d="M17.65 14.06h3.45v.993h-3.45z"></path>
    <path fill="url(#SVGRkU6lbfc)" d="M17.65 11.76h3.45v.993h-3.45z"></path>
    <path fill="url(#SVGWUBOGcFP)" d="M17.65 9.461h3.45v.993h-3.45z"></path>
    <path fill="url(#SVGFcdVfdXh)" d="M17.65 7.161h3.45v.993h-3.45z"></path>
    <path fill="url(#SVGLioYKc8j)" d="M16.237 26.721h3.45v.993h-3.45z"></path>
    <path fill="url(#SVGIx7REdei)" d="M16.237 24.421h3.45v.993h-3.45z"></path>
    <path fill="url(#SVGownHpeLf)" d="M16.237 22.121h3.45v.993h-3.45z"></path>
    <path fill="url(#SVGZ4gzmcVN)" d="M16.237 19.821h3.45v.993h-3.45z"></path>
    <path fill="url(#SVGhAblbd0u)" d="M16.237 17.522h3.45v.993h-3.45z"></path>
    <path fill="url(#SVGBzD5PbgA)" d="M17.65 27.859h3.45v.993h-3.45z"></path>
    <path fill="url(#SVGcXb6lbYS)" d="M16.237 15.222h3.45v.993h-3.45z"></path>
    <path fill="url(#SVGKF6nobvx)" d="M16.237 12.922h3.45v.993h-3.45z"></path>
    <path fill="url(#SVGrU8zSORM)" d="M16.237 10.622h3.45v.993h-3.45z"></path>
    <path fill="url(#SVGuFw9gbIu)" d="M16.237 8.322h3.45v.993h-3.45z"></path>
    <path fill="url(#SVGXh7zWblD)" d="M16.237 29.018h3.45v.993h-3.45z"></path>
    <path
      fill="url(#SVGmzaoUw6y)"
      d="M20.1 5.911a.554.554 0 0 0-.548-.53h-.009v.557h.092l.206 2.514h-2.252l.211-2.514h.094v-.557h-.044a.55.55 0 0 0-.547.53l-.314 10.569a.513.513 0 0 0 .515.531h2.432a.51.51 0 0 0 .513-.531Zm-1.384 10.5a1.171 1.171 0 1 1 1.171-1.171a1.17 1.17 0 0 1-1.171 1.168Z"
    ></path>
    <path fill="url(#SVGkZYaOeHC)" d="M18.096 3.802h1.24v3.054h-1.24z"></path>
    <path
      fill="url(#SVGVKO9QdOI)"
      d="M21.4 4.56a2.55 2.55 0 0 0-2.549-2.549h-.276a2.55 2.55 0 0 0-2.436 3.3v.006a8 8 0 0 1 .261 2.561a1.8 1.8 0 0 0 .641 1.271l.109-3.441a.593.593 0 0 1 .6-.551h.135v-1.57h1.653v1.57h.1a.6.6 0 0 1 .605.551l.121 3.462a1.8 1.8 0 0 0 .666-1.292V7.72a7.7 7.7 0 0 1 .236-2.359a2.5 2.5 0 0 0 .134-.801"
    ></path>
  </svg>
);
const ZipIcon = (props: CustomIconComponentProps) => (
  <Icon component={ZipSvg} {...props} />
);
export default ZipIcon;
